module.exports = __webpack_public_path__ + "media/images/clear-plus-blue-b1cac05f94737d32cfb56b75d3dd1163.svg";